export const DASHBOARD = "DASHBOARD"
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS"
export const DASHBOARD_FAILED = "DASHBOARD_FAILED"
